import React from 'react';
import './OfflineModeModal.scss';

interface OfflineModeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const OfflineModeModal = ({ isOpen, onClose, onConfirm }: OfflineModeModalProps) => {
  if (!isOpen) return null;

  const handleOverlayClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="modal-overlay"
      onClick={handleOverlayClick}
    >
      <div className="offline-modal">
        <button
          className="offline-modal__close"
          onClick={onClose}
        >
          ×
        </button>
        <div className="offline-modal__content">
          <h2 className="offline-modal__heading">
            Are you sure you want to enter Offline Mode?
          </h2>
          <p className="offline-modal__description">
            Please switch to offline mode <em>only</em> if you're disconnected from the
            internet, the SSO login fails, or you're facing significant problems
            in online mode. Offline mode offers limited features and is
            intended solely for critical situations.
          </p>
          <div className="offline-modal__buttons">
            <button
              className="offline-modal__button offline-modal__button--primary"
              onClick={onConfirm}
            >
              Enter Offline Mode
            </button>
            <button
              className="offline-modal__button offline-modal__button--secondary"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfflineModeModal;
